import { Box, Checkbox, Typography } from '@mui/material';
import { useState } from 'react';

import { CardWithContent } from '@/components/molecules/card-with-content';

interface Props {
  discountTemplateId: number;
  discountTemplateName: string;
  isSelected: boolean;
  toggleSelection: (checked: boolean, id: number) => void;
}

const DiscountTemplateCard = ({
  discountTemplateId,
  discountTemplateName,
  isSelected,
  toggleSelection,
}: Props) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(true);

  return (
    <CardWithContent
      isSelected={isSelected}
      onClick={() => {
        setIsCheckboxChecked(prevIsCheckboxSelected => !prevIsCheckboxSelected);
        toggleSelection(isCheckboxChecked, discountTemplateId);
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Checkbox
          checked={isSelected}
          onChange={e => {
            toggleSelection(e.target.checked, discountTemplateId);
          }}
        />
        <Typography variant="body2">{discountTemplateName}</Typography>
      </Box>
    </CardWithContent>
  );
};

export default DiscountTemplateCard;
